import { Redo } from '../../utils/editorReactIcons';
export { Redo };
export default Redo;
